// Identificador gerado no próprio aparelho, para o registro já nascer com o id
// que vai ter no servidor (dá para criar sem sinal e ligar outras coisas nele).
// crypto.randomUUID só existe em página segura (https ou localhost); no
// celular pela rede local (http) cai no getRandomValues, que funciona sempre.
export function novoId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40; // versão 4
  b[8] = (b[8] & 0x3f) | 0x80; // variante RFC 4122
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
